import {
  FormControlLabel,
  FormGroup,
  Switch as MuiSwitch,
} from "@mui/material";
import React, { Component } from "react";
import CheckIcon from "../resources/icons-check-small.svg";
import Icon from "../resources/icons-remove.svg";

export default class Switch extends Component<any> {
  constructor(props: any) {
    super(props);
  }

  render() {
    const { label, checked, disabled, onChange, sx, labelSx } = this.props;

    return (
      <FormGroup className="klayo-switch" sx={sx}>
        <FormControlLabel
          control={
            <MuiSwitch
              disableRipple={true}
              checked={checked}
              checkedIcon={
                <div className="klayo-switch_thumb">
                  <CheckIcon />
                </div>
              }
              icon={
                <div className="klayo-switch_thumb">
                  <Icon />
                </div>
              }
              disabled={disabled}
              onChange={onChange}
            />
          }
          label={label}
          sx={labelSx}
        />
      </FormGroup>
    );
  }
}
